import React, {useRef, useState} from 'react';
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

import SelectGeneric from "../../../components/select/selectGeneric";
import XailingRoutLangs from "./_langs";
import { useForm } from "react-hook-form";
import { showLoader } from "../../../components/loader/loader";
import {
	ButtonCancel,
	ButtonEdit,
	ButtonNew,
	ButtonSubmit,
	GenericTableButton
} from "../../../components/buttons/buttonsActions";
import { harborProvider } from "../../../providers/harborProvider";
import { xailingRoutService } from "../../../jwt/_services/xailing/xailingRoutService";
import { admissionProvider } from "../../../providers/admissionProvider";
import {
	FORM, INTERNATIONAL, LB_ACTIVE, LB_CODE, LB_ORDER, REQUIRED, XA_ADMISSION,
	XA_DESTINY_PORT, XA_ORIGIN_PORT
} from "../../../components/i18n/i18n";
import {FL_IMAGE} from "../../../components/i18n/formLabels";
import {PH_IMAGE} from "../../../components/i18n/placeHolders";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import TranslatedLangs from "../../../components/genericComponents/TranslatedLangs";

export default function XailingRoutForm(props) {
	const udn = JSON.parse( localStorage.getItem('selectedUdn') )
	const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
	const [editMode, setEditMode] = useState(!!props?.item?.id);
	const [disableInputs, setDisableInputs] = useState(false);
	const [saveSuccess, setSaveSuccess] = useState(false);
	const [savedData, setSavedData] = useState(editMode ? props.item : null);
	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState(editMode ? props.item?.status : false);
	const [harborFromId, setHarborFromId] = useState(editMode ? props.item?.fromHarbor.id : null);
	const [harborToId, setHarborToId] = useState(editMode ? props.item?.toHarbor.id : null);
	const [admissionId, setAdmissionId] = useState(editMode ? props.item?.admission.id : null);
	const translatableLangs = savedData?.translatedLangs || []

	const [showModal, setShowModal] = useState(true)
	const modalRef = useRef(null);

	const showHistory = () => {
		setShowModal(true);
		modalRef.current.showModal(savedData);
	}

	//to work with langs
	const refLangs = useRef(null);
	const [langChilds, setLangChilds] = useState([]);

	const validationSchema = Yup.object().shape({
		code: Yup.string().required( REQUIRED )
	});

	const {register, handleSubmit, reset, errors} = useForm({
		validationSchema: validationSchema,
		defaultValues: {
			id: savedData?.id,
			code: savedData?.code,
			showOrder : savedData?.showOrder,
			image : savedData?.image
		}
	});

	const onSubmit = (data, _) => {
		const dataRequest = {
			fbDataBase:  { id : fbDataBaseId },
			item: {
				code       : data.code,
				showOrder  : data.showOrder,
				image  	   : data.image,
				status     : status,
				udn   	   : { id : udn?.id },
				admission  : { id : admissionId },
				fromHarbor : { id : harborFromId },
				toHarbor   : { id : harborToId },
			}
		};

		if (langChilds != null && langChilds.length !== 0)
			dataRequest.item.langs = langChilds;

		setLoading(true);

		if (!editMode) {
			return xailingRoutService.saveItem(dataRequest)
				.then(resultData => setResult(resultData))
				.finally( ()=> setLoading(false) );
		} else {
			let id = savedData.id;
			dataRequest.item.id = savedData?.id

			return xailingRoutService.updateItem(id, dataRequest)
				.then(resultData => setResult(resultData))
				.finally( ()=> setLoading(false) );
		}
	};

	const onStatusChange = () => setStatus(!status);

	const setResult = (resultData) => {
		setLoading(false);
		setSavedData(resultData);
		setDisableInputs(true);
		setSaveSuccess(true);
		setEditMode(true);
		refLangs.current.changeDisabledInput(true, resultData?.langs);
	}

	const resetForm = () => {
		setSavedData(null);
		setEditMode(false);
		setDisableInputs(false);
		setSaveSuccess(false);
		refLangs.current.resetForm();
		reset();
	}

	const beginEdit = () => {
		setEditMode(true);
		setSaveSuccess(false)
		setDisableInputs(false);
		refLangs.current.changeDisabledInput(false, savedData?.langs);
	}

	const updateLangChilds = (langChildsP) => {
		if (langChildsP !== undefined) {
			setLangChilds(langChildsP);
		}
	}

	const setForm = () => props.setForm(null, null, "LIST");

	return (
		<Card>
			{loading ? showLoader() : null}
			<CardTitle className="bg-light border-bottom p-3 mb-0">
				<i className="far fa-edit mr-2"/>{FORM}
				{
					editMode && <div className="float-right">
						<GenericTableButton
							toolTip={TT_HISTORY}
							icon={'fa-clock'}
							permission={'search'}
							onClick={showHistory}
						/>
					</div>
				}
			</CardTitle>
			<CardBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<Row>
						<Col md="3">
							<FormGroup>
								<Label>{LB_CODE}</Label>
								<Input type="text" name="code"
								       placeholder="Codigo"
								       innerRef={register}
								       disabled={disableInputs}
									   className={(errors.code ? ' is-invalid' : '')}
								/>
								{ errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div> }
							</FormGroup>
						</Col>
						<Col md="3">
							<FormGroup>
								<Label>{LB_ORDER}</Label>
								<Input type="number" name="showOrder"
								       placeholder="0"
								       innerRef={register}
								       disabled={disableInputs}
								/>
							</FormGroup>
						</Col>
						<Col md="3">
							<FormGroup>
								<Label>{FL_IMAGE}</Label>
								<Input
									type="text"
									name="image"
								   	placeholder={PH_IMAGE}
								   	innerRef={register}
								   	disabled={disableInputs}
								/>
							</FormGroup>
						</Col>
						<Col md="3">
							<FormGroup>
								<Label>{LB_ACTIVE}</Label>
								<br/>
								<Switch animate={true} offText={"No"} onText={"Si"}
								        value={status}
								        disabled={disableInputs}
								        onChange={onStatusChange}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<FormGroup>
								<Label>{XA_ORIGIN_PORT}</Label>
								<SelectGeneric
									initialValue={ harborFromId }
									setExternalValue={ value => setHarborFromId( value ) }
									isDisabled={disableInputs}
									provider = { harborProvider }
								/>
							</FormGroup>
						</Col>
						<Col md="3">
							<FormGroup>
								<Label>{XA_DESTINY_PORT}</Label>
								<SelectGeneric
									initialValue={ harborToId }
									setExternalValue={ value => setHarborToId( value ) }
									isDisabled={disableInputs}
									provider = { harborProvider }
								/>
							</FormGroup>
						</Col>
						<Col md="3">
							<FormGroup>
								<Label>{XA_ADMISSION}</Label>
								<SelectGeneric
									initialValue={ admissionId }
									setExternalValue={ value => setAdmissionId( value ) }
									isDisabled={disableInputs}
									provider = { admissionProvider }
								/>
							</FormGroup>
						</Col>
					</Row>
					<CardTitle className="bg-light border-bottom p-3 mb-0">
						<i className="fas fa-language mr-2"/>{ INTERNATIONAL }
					</CardTitle>
					<CardBody>
						<TranslatedLangs translatableLangs={translatableLangs} />
						<XailingRoutLangs
							key={"LangKeyId"}
							ref={refLangs}
							xailingRout={savedData}
							setForm={setForm}
							updateItem={updateLangChilds}
							editMode={editMode}
							disableInputs={disableInputs}
						/>
					</CardBody>
					<CardBody className="border-top">
						{
							saveSuccess ?
								<div className="float-right">
									<ButtonNew onClick={ resetForm }/>
									<ButtonEdit onClick={ beginEdit }/>
									<ButtonCancel onClick={ setForm }/>
								</div>
								: <div className="float-right">
									<ButtonSubmit/>
									<ButtonCancel onClick={ setForm }/>
								</div>
						}
					</CardBody>
				</Form>
			</CardBody>
			{
				showModal && <LogHistoryModal
					ref={ modalRef }
					item={ savedData }
				/>
			}
		</Card>
	)
}